import React from "react";
import { Text, Space } from "@mantine/core";
import { Controller } from "react-hook-form";

import SelectorButton from "./SelectorButton";

const SelectorButtonRef = (props: {
  label: string;
  name: string;
  data: any;
  onSubmit: (value: any) => void;
  control: any;
  errors: any;
  watch: any;
  required?: boolean;
}) => {
  return (
    <>
      <Text fw={490} size="sm">
        {props.label}
      </Text>
      <Controller
        name={props.name}
        rules={{ validate: value => value !== undefined }}
        control={props.control}
        render={() => (
          <SelectorButton
            data={props.data}
            selected={props.watch}
            onSubmit={selectedValue => props.onSubmit(selectedValue)}
          />
        )}
      />
      {props.errors?.[props.name]?.type === "validate" && (
        <Text size="sm" style={{ color: "red" }}>
          This field is required
        </Text>
      )}
      <Space h="md" />
    </>
  );
};

export default SelectorButtonRef;
